<template>
  <div class="grid p-fluid" >
    <div class="col-12 mt-3">
        <h4 class="text-primary">تایید اطلاعات</h4>
        <h6>در صورت اطمینان از کامل شدن همه بخش های فرایند، جهت انتشار مکان خود تایید کنید</h6>
    </div>
    <div v-if="!!errors.length" class="col-12 mt-3">
        <h6 class="text-red-500">موارد زیر باید رفع شوند:</h6>
        <div class="text-red-500" v-for="(error , index) in errors" :key="`error-${index}`">
            <small>
                ⁕ {{error}}
            </small>
        </div>
    </div>
    <div class="col-12 flex flex-row justify-content-end mt-3">
        <span class="p-float-label w-full md:w-3">
            <Button type="button" class="mr-2 mb-2" label="تایید" icon="pi pi-check" :loading="loading['create']" @click.prevent="completePlaceSections(placeId)"/>
        </span>
    </div>
  </div>
</template>

<script>
export default {
    name:'checkStatus',
    props:{
        placeId:{
            type: Number,
            default: null,
        },
    },
    data(){
        return {
            loading:{
                create:false,
            },
            errorMessages:{
                "pictures_should_be_more_5": 'تعداد تصاویر باید بیشتر از 5 عدد باشد.',
                "should_fill_rules": 'بخش قوانین کامل شود',
                "should_fill_features": 'بخش ویژگی ها تکمیل نشده است.'
            },
            errors:[],
        }
    },
    methods:{
        async completePlaceSections(id){
            // debugger
            this.loading['create'] = true;
            const {status , data} = await this.axios.patch(`Place/${id}/complete`)
            // this.$emit('create-event',status)
            if(status === 400){
                const dataErrors = data.errors.object;
                this.errors = dataErrors.map(item=>this.errorMessages[item] || '').filter(er=> !!er)
            }else if(status === 200){
                this.showToast(status);
                setTimeout(() => {
                    this.$router.push('/place/list');
                },800)
            }
            this.loading['create'] = false;
        },
        convertDate(date){
            if(date === '' || typeof date == 'object') return `${new Date(date).getHours()}:${new Date(date).getMinutes()}`
                return date
        },
    },
}
</script>

<style lang="scss">
.p-datepicker.p-component.p-datepicker-timeonly{
    direction: ltr;
}
</style>